import { dom, library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBars,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faDownToBracket,
  faEnvelope,
  faEye,
  faEyes,
  faEyeSlash,
  faFilter,
  faGear,
  faGlobe,
  faHome,
  faLink,
  faLinkSimple,
  faList,
  faPaperPlane,
  faPenToSquare,
  faPodcast,
  faRightFromBracket,
  faRightToBracket,
  faRocketLaunch,
  faStar,
  faThumbTack,
  faTimes,
  faTriangleExclamation,
  faUserCircle,
  faUserVneckHair,
} from '@fortawesome/pro-regular-svg-icons'
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons'
import {
  faBluesky,
  faFacebook,
  faInstagram,
  faLinkedin,
  faThreads,
  faTiktok,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBadgeCheck,
  faBars,
  faBluesky,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faDownToBracket,
  faEnvelope,
  faEye,
  faEyes,
  faEyeSlash,
  faFacebook,
  faFilter,
  faGear,
  faGlobe,
  faHome,
  faInstagram,
  faLink,
  faLinkedin,
  faLinkSimple,
  faList,
  faPaperPlane,
  faPenToSquare,
  faPodcast,
  faRightFromBracket,
  faRightToBracket,
  faRocketLaunch,
  faStar,
  faThreads,
  faThumbTack,
  faTiktok,
  faTimes,
  faTriangleExclamation,
  faUserCircle,
  faUserVneckHair,
  faXTwitter,
  faYoutube
)

dom.watch()
